import React, { useEffect, useState } from 'react';
import { getCurrentUser, getSession } from '../../lib/auth-session.js';
import { C, LAYOUT } from '../../shared/design-tokens.js';

interface SessionState {
  loading: boolean;
  hasSession: boolean;
  hasUser: boolean;
  error: { message?: string } | null;
}

export default function SessionCheck() {
  const [state, setState] = useState<SessionState>({ loading: true, hasSession: false, hasUser: false, error: null });

  useEffect(() => {
    let active = true;

    async function run() {
      const [{ session, error: sessionError }, { user, error: userError }] = await Promise.all([
        getSession(),
        getCurrentUser(),
      ]);

      if (!active) return;

      setState({
        loading: false,
        hasSession: !!session,
        hasUser: !!user,
        error: sessionError || userError || null,
      });
    }

    run();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.textMuted, marginBottom: 8 }}>
        Auth / session helper check
      </div>
      <div style={{ lineHeight: 1.7 }}>
        <div>Loading: <span style={{ color: state.loading ? C.gold : C.text }}>{state.loading ? 'yes' : 'no'}</span></div>
        <div>Session present: <span style={{ color: state.hasSession ? C.green : C.textMuted }}>{state.hasSession ? 'yes' : 'no'}</span></div>
        <div>User present: <span style={{ color: state.hasUser ? C.green : C.textMuted }}>{state.hasUser ? 'yes' : 'no'}</span></div>
        <div>Error: <span style={{ color: state.error ? C.red : C.textMuted }}>{state.error ? state.error.message || 'unknown' : 'none'}</span></div>
      </div>
    </div>
  );
}
